import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "form" };
const _hoisted_2 = { class: "form-details" };
const _hoisted_3 = {
    key: 0,
    class: "form-menu"
};
const _hoisted_4 = { class: "float-end" };
const _hoisted_5 = { class: "form-contents" };
const _hoisted_6 = { class: "row" };
const _hoisted_7 = { class: "clearfix" };
const _hoisted_8 = { class: "col-xs-12 col-sm-12 col-md-3" };
const _hoisted_9 = { class: "input-group top_search" };
const _hoisted_10 = { class: "input-group-btn" };
const _hoisted_11 = { class: "col-xs-12 col-sm-12 col-md-3" };
const _hoisted_12 = { class: "input-group top_search" };
const _hoisted_13 = { class: "col-xs-12 col-sm-12 col-md-3" };
const _hoisted_14 = { class: "input-group top_search" };
const _hoisted_15 = { class: "col-xs-12 col-sm-12 col-md-3" };
const _hoisted_16 = { class: "input-group top_search" };
const _hoisted_17 = { class: "col-xs-12 col-sm-12 col-md-12" };
const _hoisted_18 = { class: "clearfix data-grid-top-pagination" };
const _hoisted_19 = { class: "float-end left5" };
const _hoisted_20 = { class: "clearfix pad10" };
const _hoisted_21 = { class: "float-end" };
const _hoisted_22 = {
    key: 0,
    class: "float-end"
};
const _hoisted_23 = { class: "float-end hidden-xs record-count" };
const _hoisted_24 = { class: "col-xs-12 col-sm-12" };
const _hoisted_25 = { class: "card bg-white data-grid systems-grid detached overflow-x-auto" };
const _hoisted_26 = { class: "table table-hover bottom0 pw100" };
const _hoisted_27 = { key: 0 };
const _hoisted_28 = { key: 1 };
const _hoisted_29 = {
    key: 2,
    class: "hidden-sm"
};
const _hoisted_30 = {
    key: 3,
    class: "hidden-sm"
};
const _hoisted_31 = {
    key: 4,
    class: "hidden-sm"
};
const _hoisted_32 = { class: "text-center hidden-sm" };
const _hoisted_33 = { key: 0 };
const _hoisted_34 = { class: "clearfix visible-sm" };
const _hoisted_35 = { class: "clearfix" };
const _hoisted_36 = { class: "clearfix" };
const _hoisted_37 = { class: "clearfix" };
const _hoisted_38 = { class: "float-start" };
const _hoisted_39 = { key: 1 };
const _hoisted_40 = {
    key: 2,
    class: "hidden-sm"
};
const _hoisted_41 = {
    key: 3,
    class: "hidden-sm"
};
const _hoisted_42 = {
    key: 4,
    class: "hidden-sm"
};
const _hoisted_43 = { key: 0 };
const _hoisted_44 = ["colspan"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_button = _resolveComponent("b-button");
    const _component_router_link = _resolveComponent("router-link");
    const _component_b_form_input = _resolveComponent("b-form-input");
    const _component_multiselect = _resolveComponent("multiselect");
    const _component_b_form_checkbox = _resolveComponent("b-form-checkbox");
    const _component_b_form_group = _resolveComponent("b-form-group");
    const _component_b_dropdown_form = _resolveComponent("b-dropdown-form");
    const _component_b_dropdown_divider = _resolveComponent("b-dropdown-divider");
    const _component_b_dropdown = _resolveComponent("b-dropdown");
    const _component_b_pagination = _resolveComponent("b-pagination");
    const _component_SortableColumnComponent = _resolveComponent("SortableColumnComponent");
    const _component_b_dropdown_item = _resolveComponent("b-dropdown-item");
    const _component_b_button_group = _resolveComponent("b-button-group");
    const _component_ImportSystemFromZipModal = _resolveComponent("ImportSystemFromZipModal");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _cache[10] || (_cache[10] = _createElementVNode("div", { class: "form-title" }, [
                _createElementVNode("h2", null, "\r\n\t\t\t\t\tSystems\r\n\t\t\t\t")
            ], -1 /* CACHED */)),
            _cache[11] || (_cache[11] = _createTextVNode()),
            (_ctx.isClientAdministrator)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                        (_ctx.canImportFromZip)
                            ? (_openBlock(), _createBlock(_component_b_button, {
                                key: 0,
                                variant: "outline-primary",
                                class: "me-2",
                                onClick: _ctx.showImportModal
                            }, {
                                default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                                        _createElementVNode("span", { class: "fa fa-upload" }, null, -1 /* CACHED */),
                                        _createElementVNode("span", { class: "hidden-xs" }, " Import Controller Data", -1 /* CACHED */)
                                    ]))]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["onClick"]))
                            : _createCommentVNode("v-if", true),
                        _cache[9] || (_cache[9] = _createTextVNode()),
                        (_ctx.isClientAdministrator)
                            ? (_openBlock(), _createBlock(_component_router_link, {
                                key: 1,
                                to: { name: 'system' }
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_b_button, { variant: "primary" }, {
                                        default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                                                _createElementVNode("span", { class: "fa fa-plus" }, null, -1 /* CACHED */),
                                                _createElementVNode("span", { class: "hidden-xs" }, " Add System", -1 /* CACHED */)
                                            ]))]),
                                        _: 1 /* STABLE */
                                    })
                                ]),
                                _: 1 /* STABLE */
                            }))
                            : _createCommentVNode("v-if", true)
                    ])
                ]))
                : _createCommentVNode("v-if", true)
        ]),
        _cache[59] || (_cache[59] = _createTextVNode()),
        _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                            _createVNode(_component_b_form_input, {
                                type: "text",
                                modelValue: _ctx.query.keywords,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.query.keywords) = $event)),
                                modelModifiers: { trim: true },
                                placeholder: "Search for...",
                                onKeyup: _withKeys(_ctx.search, ["enter"]),
                                required: ""
                            }, null, 8 /* PROPS */, ["modelValue", "onKeyup"]),
                            _cache[13] || (_cache[13] = _createTextVNode()),
                            _createElementVNode("span", _hoisted_10, [
                                _createElementVNode("button", {
                                    type: "button",
                                    class: "btn btn-default",
                                    onClick: _cache[1] || (_cache[1] =
                                        //@ts-ignore
                                        (...args) => (_ctx.search && _ctx.search(...args)))
                                }, [...(_cache[12] || (_cache[12] = [
                                        _createElementVNode("i", { class: "fa fa-search" }, null, -1 /* CACHED */)
                                    ]))])
                            ])
                        ])
                    ]),
                    _cache[17] || (_cache[17] = _createTextVNode()),
                    _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                            _createVNode(_component_multiselect, {
                                modelValue: _ctx.companyId,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.companyId) = $event)),
                                options: _ctx.companies,
                                "track-by": "value",
                                label: "text",
                                showLabels: false,
                                placeholder: "All companies",
                                class: "multiselect-small"
                            }, {
                                noResult: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                                        _createTextVNode("\r\n\t\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                    ]))]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["modelValue", "options"])
                        ])
                    ]),
                    _cache[18] || (_cache[18] = _createTextVNode()),
                    _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                            _createVNode(_component_multiselect, {
                                modelValue: _ctx.siteId,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.siteId) = $event)),
                                options: _ctx.filteredSites,
                                "track-by": "value",
                                label: "text",
                                showLabels: false,
                                placeholder: "All sites",
                                class: "multiselect-small"
                            }, {
                                noResult: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                                        _createTextVNode("\r\n\t\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                    ]))]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["modelValue", "options"])
                        ])
                    ]),
                    _cache[19] || (_cache[19] = _createTextVNode()),
                    _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                            _createVNode(_component_multiselect, {
                                modelValue: _ctx.city,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.city) = $event)),
                                options: _ctx.filteredCities,
                                "track-by": "value",
                                label: "text",
                                showLabels: false,
                                placeholder: "All cities",
                                class: "multiselect-small"
                            }, {
                                noResult: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                                        _createTextVNode("\r\n\t\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                    ]))]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["modelValue", "options"])
                        ])
                    ])
                ]),
                _cache[55] || (_cache[55] = _createTextVNode()),
                _cache[56] || (_cache[56] = _createElementVNode("div", { class: "clearfix" }, null, -1 /* CACHED */)),
                _cache[57] || (_cache[57] = _createTextVNode()),
                _withDirectives(_createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("div", _hoisted_19, [
                            _createVNode(_component_b_dropdown, {
                                ref: "columnSettingsDropdown",
                                "no-caret": "",
                                end: "",
                                sm: "",
                                "auto-close": false,
                                variant: "outline-secondary outline-secondary-pagination",
                                disabled: _ctx.working
                            }, {
                                "button-content": _withCtx(() => [...(_cache[20] || (_cache[20] = [
                                        _createElementVNode("i", { class: "fa fa-cog" }, null, -1 /* CACHED */)
                                    ]))]),
                                default: _withCtx(() => [
                                    _cache[26] || (_cache[26] = _createTextVNode()),
                                    _createVNode(_component_b_dropdown_form, { class: "column-settings-dropdown" }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_b_form_group, null, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_b_form_checkbox, {
                                                        id: "includeDeleted",
                                                        modelValue: _ctx.query.includeDeleted,
                                                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.query.includeDeleted) = $event))
                                                    }, {
                                                        default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                                                                _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\t\tShow archived\r\n\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                                            ]))]),
                                                        _: 1 /* STABLE */
                                                    }, 8 /* PROPS */, ["modelValue"])
                                                ]),
                                                _: 1 /* STABLE */
                                            }),
                                            _cache[22] || (_cache[22] = _createTextVNode()),
                                            _cache[23] || (_cache[23] = _createElementVNode("div", { class: "clearfix top10" }, [
                                                _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\t\tColumn visibility\r\n\t\t\t\t\t\t\t\t\t\t")
                                            ], -1 /* CACHED */)),
                                            _cache[24] || (_cache[24] = _createTextVNode()),
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column, columnIdx) => {
                                                return (_openBlock(), _createBlock(_component_b_form_group, {
                                                    key: column.fieldName
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_component_b_form_group, null, {
                                                            default: _withCtx(() => [
                                                                _createVNode(_component_b_form_checkbox, {
                                                                    id: column.fieldName,
                                                                    modelValue: column.visible,
                                                                    "onUpdate:modelValue": ($event) => ((column.visible) = $event)
                                                                }, {
                                                                    default: _withCtx(() => [
                                                                        _createTextVNode(_toDisplayString(column.title), 1 /* TEXT */)
                                                                    ]),
                                                                    _: 2 /* DYNAMIC */
                                                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["id", "modelValue", "onUpdate:modelValue"])
                                                            ]),
                                                            _: 2 /* DYNAMIC */
                                                        }, 1024 /* DYNAMIC_SLOTS */)
                                                    ]),
                                                    _: 2 /* DYNAMIC */
                                                }, 1024 /* DYNAMIC_SLOTS */));
                                            }), 128 /* KEYED_FRAGMENT */))
                                        ]),
                                        _: 1 /* STABLE */
                                    }),
                                    _cache[27] || (_cache[27] = _createTextVNode()),
                                    _createVNode(_component_b_dropdown_divider),
                                    _cache[28] || (_cache[28] = _createTextVNode()),
                                    _createElementVNode("div", _hoisted_20, [
                                        _createElementVNode("div", _hoisted_21, [
                                            _createVNode(_component_b_button, {
                                                variant: "secondary",
                                                right: "",
                                                sm: "",
                                                onClick: _ctx.closeColumnSettingsMenu
                                            }, {
                                                default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                                                        _createElementVNode("i", { class: "fa fa-times" }, null, -1 /* CACHED */),
                                                        _createTextVNode(" Close\r\n\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                                    ]))]),
                                                _: 1 /* STABLE */
                                            }, 8 /* PROPS */, ["onClick"])
                                        ])
                                    ])
                                ]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["disabled"])
                        ]),
                        _cache[29] || (_cache[29] = _createTextVNode()),
                        (_ctx.numberOfVisibleColumns)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                _createVNode(_component_b_pagination, {
                                    class: "float-end",
                                    modelValue: _ctx.query.pageNo,
                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.query.pageNo) = $event)),
                                    "per-page": _ctx.query.pageSize,
                                    "total-rows": _ctx.data.recordCount,
                                    "hide-ellipsis": true,
                                    disabled: _ctx.working
                                }, null, 8 /* PROPS */, ["modelValue", "per-page", "total-rows", "disabled"])
                            ]))
                            : _createCommentVNode("v-if", true),
                        _cache[30] || (_cache[30] = _createTextVNode()),
                        _createElementVNode("div", _hoisted_23, "\r\n\t\t\t\t\t\t\tItems: " + _toDisplayString(_ctx.data.recordCount), 1 /* TEXT */)
                    ])
                ], 512 /* NEED_PATCH */), [
                    [_vShow, _ctx.searchAttempted]
                ]),
                _cache[58] || (_cache[58] = _createTextVNode()),
                _withDirectives(_createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("table", _hoisted_26, [
                            _createElementVNode("thead", null, [
                                _createElementVNode("tr", null, [
                                    _cache[31] || (_cache[31] = _createElementVNode("th", { class: "text-center hidden-sm w40 no-min-width" }, null, -1 /* CACHED */)),
                                    _cache[32] || (_cache[32] = _createTextVNode()),
                                    (_ctx.isVisible('systemName'))
                                        ? (_openBlock(), _createElementBlock("th", _hoisted_27, [
                                            _createVNode(_component_SortableColumnComponent, {
                                                sorter: _ctx.sorter,
                                                column: { fieldName: 'SystemName', title: 'System' }
                                            }, null, 8 /* PROPS */, ["sorter"])
                                        ]))
                                        : _createCommentVNode("v-if", true),
                                    _cache[33] || (_cache[33] = _createTextVNode()),
                                    (_ctx.isVisible('serialNumber'))
                                        ? (_openBlock(), _createElementBlock("th", _hoisted_28, [
                                            _createVNode(_component_SortableColumnComponent, {
                                                sorter: _ctx.sorter,
                                                column: { fieldName: 'SerialNumberKeywords', title: 'Serial Number' }
                                            }, null, 8 /* PROPS */, ["sorter"])
                                        ]))
                                        : _createCommentVNode("v-if", true),
                                    _cache[34] || (_cache[34] = _createTextVNode()),
                                    (_ctx.isVisible('siteName'))
                                        ? (_openBlock(), _createElementBlock("th", _hoisted_29, [
                                            _createVNode(_component_SortableColumnComponent, {
                                                sorter: _ctx.sorter,
                                                column: { fieldName: 'SiteName', title: 'Site' }
                                            }, null, 8 /* PROPS */, ["sorter"])
                                        ]))
                                        : _createCommentVNode("v-if", true),
                                    _cache[35] || (_cache[35] = _createTextVNode()),
                                    (_ctx.isVisible('streetAddress3'))
                                        ? (_openBlock(), _createElementBlock("th", _hoisted_30, [
                                            _createVNode(_component_SortableColumnComponent, {
                                                sorter: _ctx.sorter,
                                                column: { fieldName: 'StreetAddress3', title: 'City' }
                                            }, null, 8 /* PROPS */, ["sorter"])
                                        ]))
                                        : _createCommentVNode("v-if", true),
                                    _cache[36] || (_cache[36] = _createTextVNode()),
                                    (_ctx.isVisible('companyName'))
                                        ? (_openBlock(), _createElementBlock("th", _hoisted_31, [
                                            _createVNode(_component_SortableColumnComponent, {
                                                sorter: _ctx.sorter,
                                                column: { fieldName: 'CompanyName', title: 'Company' }
                                            }, null, 8 /* PROPS */, ["sorter"])
                                        ]))
                                        : _createCommentVNode("v-if", true)
                                ])
                            ]),
                            _cache[53] || (_cache[53] = _createTextVNode()),
                            _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.records, (item) => {
                                    return (_openBlock(), _createElementBlock("tr", {
                                        class: _normalizeClass({ 'deleted': item.whenDeleted })
                                    }, [
                                        _createElementVNode("td", _hoisted_32, [
                                            _createVNode(_component_b_button_group, null, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_b_dropdown, {
                                                        variant: "outline-secondary dots",
                                                        size: "sm",
                                                        onClick: ($event) => (_ctx.edit(item))
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createVNode(_component_b_dropdown_item, {
                                                                onClick: ($event) => (_ctx.edit(item))
                                                            }, {
                                                                default: _withCtx(() => [...(_cache[37] || (_cache[37] = [
                                                                        _createElementVNode("span", { class: "fa fa-pencil" }, null, -1 /* CACHED */),
                                                                        _createTextVNode(" Edit\r\n\t\t\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                                                    ]))]),
                                                                _: 1 /* STABLE */
                                                            }, 8 /* PROPS */, ["onClick"]),
                                                            _cache[40] || (_cache[40] = _createTextVNode()),
                                                            (_ctx.isClientAdministrator)
                                                                ? (_openBlock(), _createBlock(_component_b_dropdown_divider, { key: 0 }))
                                                                : _createCommentVNode("v-if", true),
                                                            _cache[41] || (_cache[41] = _createTextVNode()),
                                                            (_ctx.isClientAdministrator)
                                                                ? _withDirectives((_openBlock(), _createBlock(_component_b_dropdown_item, {
                                                                    key: 1,
                                                                    onClick: ($event) => (_ctx.archive(item))
                                                                }, {
                                                                    default: _withCtx(() => [...(_cache[38] || (_cache[38] = [
                                                                            _createElementVNode("span", { class: "fa fa-trash" }, null, -1 /* CACHED */),
                                                                            _createTextVNode(" Archive\r\n\t\t\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                                                        ]))]),
                                                                    _: 1 /* STABLE */
                                                                }, 8 /* PROPS */, ["onClick"])), [
                                                                    [_vShow, !item.whenDeleted]
                                                                ])
                                                                : _createCommentVNode("v-if", true),
                                                            _cache[42] || (_cache[42] = _createTextVNode()),
                                                            (_ctx.isClientAdministrator)
                                                                ? _withDirectives((_openBlock(), _createBlock(_component_b_dropdown_item, {
                                                                    key: 2,
                                                                    onClick: ($event) => (_ctx.restore(item))
                                                                }, {
                                                                    default: _withCtx(() => [...(_cache[39] || (_cache[39] = [
                                                                            _createElementVNode("span", { class: "fa fa-refresh" }, null, -1 /* CACHED */),
                                                                            _createTextVNode(" Restore\r\n\t\t\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                                                        ]))]),
                                                                    _: 1 /* STABLE */
                                                                }, 8 /* PROPS */, ["onClick"])), [
                                                                    [_vShow, item.whenDeleted]
                                                                ])
                                                                : _createCommentVNode("v-if", true)
                                                        ]),
                                                        _: 2 /* DYNAMIC */
                                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"])
                                                ]),
                                                _: 2 /* DYNAMIC */
                                            }, 1024 /* DYNAMIC_SLOTS */)
                                        ]),
                                        _cache[47] || (_cache[47] = _createTextVNode()),
                                        (_ctx.isVisible('systemName'))
                                            ? (_openBlock(), _createElementBlock("td", _hoisted_33, [
                                                _createVNode(_component_router_link, {
                                                    to: { name: 'system', params: { 'id': item.systemId } },
                                                    class: "blue hidden-sm"
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(item.systemName), 1 /* TEXT */)
                                                    ]),
                                                    _: 2 /* DYNAMIC */
                                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"]),
                                                _cache[46] || (_cache[46] = _createTextVNode()),
                                                _createElementVNode("div", _hoisted_34, [
                                                    _createVNode(_component_router_link, {
                                                        to: { name: 'system', params: { 'id': item.systemId } },
                                                        class: "lead"
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(item.systemName), 1 /* TEXT */)
                                                        ]),
                                                        _: 2 /* DYNAMIC */
                                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"]),
                                                    _cache[45] || (_cache[45] = _createTextVNode()),
                                                    _createElementVNode("div", _hoisted_35, [
                                                        _createElementVNode("div", _hoisted_36, _toDisplayString(item.companyName), 1 /* TEXT */),
                                                        _cache[44] || (_cache[44] = _createTextVNode()),
                                                        _createElementVNode("div", _hoisted_37, [
                                                            _createElementVNode("div", _hoisted_38, [
                                                                _cache[43] || (_cache[43] = _createElementVNode("i", { class: "fa fa-map-marker" }, null, -1 /* CACHED */)),
                                                                _createTextVNode(" " + _toDisplayString(item.siteName), 1 /* TEXT */)
                                                            ])
                                                        ])
                                                    ])
                                                ])
                                            ]))
                                            : _createCommentVNode("v-if", true),
                                        _cache[48] || (_cache[48] = _createTextVNode()),
                                        (_ctx.isVisible('serialNumber'))
                                            ? (_openBlock(), _createElementBlock("td", _hoisted_39, _toDisplayString(item.serialNumberKeywords), 1 /* TEXT */))
                                            : _createCommentVNode("v-if", true),
                                        _cache[49] || (_cache[49] = _createTextVNode()),
                                        (_ctx.isVisible('siteName'))
                                            ? (_openBlock(), _createElementBlock("td", _hoisted_40, _toDisplayString(item.siteName), 1 /* TEXT */))
                                            : _createCommentVNode("v-if", true),
                                        _cache[50] || (_cache[50] = _createTextVNode()),
                                        (_ctx.isVisible('streetAddress3'))
                                            ? (_openBlock(), _createElementBlock("td", _hoisted_41, _toDisplayString(item.streetAddress3), 1 /* TEXT */))
                                            : _createCommentVNode("v-if", true),
                                        _cache[51] || (_cache[51] = _createTextVNode()),
                                        (_ctx.isVisible('companyName'))
                                            ? (_openBlock(), _createElementBlock("td", _hoisted_42, _toDisplayString(item.companyName), 1 /* TEXT */))
                                            : _createCommentVNode("v-if", true)
                                    ], 2 /* CLASS */));
                                }), 256 /* UNKEYED_FRAGMENT */))
                            ]),
                            _cache[54] || (_cache[54] = _createTextVNode()),
                            _createElementVNode("tfoot", null, [
                                (_ctx.noData)
                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_43, [
                                        _createElementVNode("td", {
                                            class: "text-center",
                                            colspan: _ctx.numberOfVisibleColumns + 1
                                        }, [...(_cache[52] || (_cache[52] = [
                                                _createElementVNode("h5", null, "\r\n\t\t\t\t\t\t\t\t\t\t\tThere are no records matching your criteria.\r\n\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                            ]))], 8 /* PROPS */, _hoisted_44)
                                    ]))
                                    : _createCommentVNode("v-if", true)
                            ])
                        ])
                    ])
                ], 512 /* NEED_PATCH */), [
                    [_vShow, _ctx.searchAttempted]
                ])
            ])
        ]),
        _cache[60] || (_cache[60] = _createTextVNode()),
        _createCommentVNode(" Import System from ZIP Modal "),
        _cache[61] || (_cache[61] = _createTextVNode()),
        _createVNode(_component_ImportSystemFromZipModal, {
            ref: "importModal",
            companies: _ctx.companies,
            sites: _ctx.sites,
            onImportQueued: _ctx.onImportQueued
        }, null, 8 /* PROPS */, ["companies", "sites", "onImportQueued"])
    ]));
}
